// history.js
import { createBrowserHistory } from 'history'

let history = createBrowserHistory({
    /* pass a configuration object here if needed */
})

export default history;